import styles from './Dots.module.css';

/** Three dots that breathe while something is in progress. Sits inside the control that started it. */
export function Dots({ label = 'Working' }: { label?: string }) {
  return (
    <span className={styles.dots} role="status" aria-label={label}>
      <i />
      <i />
      <i />
    </span>
  );
}
